var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#2B65CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5901 25.33L17.9701 20.732L19.8181 18.884L24.4161 23.482L22.5901 25.33ZM17.0021 25.33C15.4181 25.33 14.0504 24.9853 12.8991 24.296C11.7551 23.6067 10.8714 22.6423 10.2481 21.403C9.63206 20.1637 9.32406 18.7227 9.32406 17.08C9.32406 15.4373 9.63206 13.9963 10.2481 12.757C10.8714 11.5177 11.7551 10.5533 12.8991 9.864C14.0504 9.17467 15.4181 8.83 17.0021 8.83C18.5861 8.83 19.9501 9.17467 21.0941 9.864C22.2454 10.5533 23.1291 11.5177 23.7451 12.757C24.3684 13.9963 24.6801 15.4373 24.6801 17.08C24.6801 18.7227 24.3684 20.1637 23.7451 21.403C23.1291 22.6423 22.2454 23.6067 21.0941 24.296C19.9501 24.9853 18.5861 25.33 17.0021 25.33ZM17.0021 22.514C18.0067 22.5287 18.8427 22.3123 19.5101 21.865C20.1774 21.4177 20.6761 20.7833 21.0061 19.962C21.3434 19.1407 21.5121 18.18 21.5121 17.08C21.5121 15.98 21.3434 15.0267 21.0061 14.22C20.6761 13.4133 20.1774 12.7863 19.5101 12.339C18.8427 11.8917 18.0067 11.6607 17.0021 11.646C15.9974 11.6313 15.1614 11.8477 14.4941 12.295C13.8267 12.7423 13.3244 13.3767 12.9871 14.198C12.6571 15.0193 12.4921 15.98 12.4921 17.08C12.4921 18.18 12.6571 19.1333 12.9871 19.94C13.3244 20.7467 13.8267 21.3737 14.4941 21.821C15.1614 22.2683 15.9974 22.4993 17.0021 22.514Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQd);
export default __webpack_public_path__ + "static/media/qd.d92624a95054fefb410ae60a8fffe7cf.svg";
export { ForwardRef as ReactComponent };